import React, { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';
import { addClasses, removeClasses } from '../../../js/utils/html';

const alertIcons = {
  'default': 'fa-exclamation-circle',
  'info': 'fa-info',
  'success': 'fa-check',
  'warning': 'fa-warning',
  'error': 'fa-ban',
};

const alertMessages = {
  'default': 'This is an alert',
  'info': 'This is an info alert',
  'success': 'This is a success alert',
  'warning': 'This is a warning alert',
  'error': 'This is an error alert',
};
class Alerts extends Component {

  componentDidMount() {
    setTimeout(() => {
      this.initializeAlerts();
    }, 0);
  }

  initializeAlerts() {
    for (const alertTypeSelector of document.querySelectorAll('.alert-type-selector')) {
      alertTypeSelector.addEventListener('change', this.changeAlerts.bind(this), false);
    }
  }

  changeAlerts(event) {
    const target = event.currentTarget;
    const type = target.value;
    const selector = target.dataset.selector;
    const alertEls = document.querySelectorAll(selector);
    for (const alertEl of alertEls) {
      const alertIconEl = alertEl.querySelector('.alert__icon > i');
      const alertHeadingEl = alertEl.querySelector('.alert__heading');
      const alertMessageEl = alertEl.querySelector('.alert__message');
      removeClasses(alertEl, [ 'alert--info', 'alert--success', 'alert--warning', 'alert--error' ]);
      addClasses(alertEl, [ `alert--${ type }` ]);

      // Update the icon, if there is one
      if (alertIconEl) {
        removeClasses(alertIconEl, Object.values(alertIcons));
        addClasses(alertIconEl, [ alertIcons[type] ]);
      }

      // Update the heading, if there is one
      if (alertHeadingEl) {
        alertHeadingEl.innerHTML = alertMessages[type];
      }

      // Update the message, if there is one
      if (alertMessageEl) {
        alertMessageEl.innerHTML = alertMessages[type];
      }
    }
  }

  render() {
    return (
    <section><a className="anchor"id="alerts"></a>
      <h2>Alerts</h2>
      <p>Messages are a way to provide feedback to users:</p>
      <ul>
        <li>Information messages can be used to inform the user about something relevant or to share tips or suggestions.</li>
        <li>Warnings should be displayed for example when there is something wrong with the system or the user’s task can’t be fully completed.</li>
        <li>Success messages tell people they have successfully completed a task, for example submitted a form. </li>
        <li>Error messages let people know that something has gone wrong and it needs to be resolved to complete the task. Errors and success messages are the most important message types, but sometimes you might need also other types of messages.</li>
      </ul>

      <DarkThemeNav anchor="alerts" />

      <br/>
      <h4>Default Alert</h4>
      <div className="push-half--bottom">
        <label htmlFor="alert-type-default" className="display--inline-block push-half--right">Change Type:</label>
        <select id="alert-type-default" className="alert-type-selector" data-selector=".js-alert--default">
          <option value="default">Default</option>
          <option value="info">Info</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>
      <div className="alert js-alert--default" role="alert">This is an alert</div>
      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="alert" role="alert">This is an alert</div>
<div class="alert alert--info" role="alert">This is an info alert</div>
<div class="alert alert--warning" role="alert">This is a warning alert</div>
<div class="alert alert--success" role="alert">This is a success alert</div>
<div class="alert alert--error" role="alert">This is an error alert</div>`}</code></pre>

      <h4>Light Alert</h4>
      <p>An alternative alert can be used in the same manner as the default alert, but is particularly useful when we need to include either links and/or buttons.</p>

      <div className="push-half--bottom">
        <label htmlFor="alert-type-light" className="display--inline-block push-half--right">Change Type:</label>
        <select id="alert-type-light" className="alert-type-selector" data-selector=".js-alert--light">
          <option value="default">Default</option>
          <option value="info">Info</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>

      <div className="alert alert--light js-alert--light" role="alert">
        This is an alert
        <button className="alert__close btn btn--transparent js-alert__close" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>
      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Default Light Alert -->
<div class="alert alert--light js-alert" role="alert">
  This is a light alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Info Light Alert -->
<div class="alert alert--light alert--info js-alert" role="alert">
  This is a light info alert, with a <button class="btn btn--small push-quarter--left">button</button>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Success Light Alert -->
<div class="alert alert--light alert--success js-alert" role="alert">
  This is a light success alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Warning Light Alert -->
<div class="alert alert--light alert--warning js-alert" role="alert">
  This is a light warning alert, with a <a href="#">link</a> and a <button class="btn btn--small push-quarter--left">button</button>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Error Light Alert -->
<div class="alert alert--light alert--error js-alert" role="alert">
  This is a light error alert, with a <button class="btn btn--small push-quarter--left">button</button>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>`}
      </code></pre>
      <br/>
      <h4>Attention Alert</h4>

      <div className="push-half--bottom">
        <label htmlFor="alert-type-attention" className="display--inline-block push-half--right">Change Type:</label>
        <select id="alert-type-attention" className="alert-type-selector" data-selector=".js-alert--attention">
          <option value="default">Default</option>
          <option value="info">Info</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>

      <div className="alert js-alert--attention" role="alert">
        <div className="alert__icon">
          <i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
        </div>
        <div className="alert__heading">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent js-alert__close" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Default Attention Alert -->
<div class="alert js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Info Attention Alert -->
<div class="alert alert--info js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-info-circle icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is an info alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Success Attention Alert -->
<div class="alert alert--success js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-check icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is a success alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Success Attention Alert -->
<div class="alert alert--success js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-check icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is a success alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Warning Attention Alert -->
<div class="alert alert--warning js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-triangle icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is a warning alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Error Attention Alert -->
<div class="alert alert--error js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-ban icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is an error alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>`}</code></pre>
      <br/>

      <h4>Minimal Alert</h4>
      <div className="push-half-bottom">
        <label htmlFor="alert-type-minimal" className="display--inline-block push-half--right">Change Type:</label>
        <select id="alert-type-minimal" className="alert-type-selector" data-selector=".js-alert--minimal">
          <option value="default">Default</option>
          <option value="info">Info</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>

      <h5 className="push--top push-half--bottom">Minimal Alert with Block Icon and Colored Outline</h5>
      <div className="alert alert--minimal alert--outline js-alert--minimal" role="alert">
        <div className="alert__icon alert__icon--block">
          <i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
        </div>
        <div className="alert__message">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>

      <h5 className="push--top push-half--bottom">Minimal Alert with Icon and Colored Outline</h5>
      <div className="alert alert--minimal alert--outline js-alert--minimal" role="alert">
        <div className="alert__icon">
          <i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
        </div>
        <div className="alert__message">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>

      <h5 className="push--top push-half--bottom">Minimal Alert with Icon and Gray Outline</h5>
      <div className="alert alert--minimal js-alert--minimal" role="alert">
        <div className="alert__icon">
          <i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
        </div>
        <div className="alert__message">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>

      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Minimal Alert with Block Icon and Colored Outline -->
<div class="alert alert--minimal alert--outline" role="alert">
  <div class="alert__icon alert__icon--block">
    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__message">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Minimal Alert with Icon and Colored Outline -->
<div class="alert alert--minimal alert--outline" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__message">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Minimal Alert with Icon and Gray Outline -->
<div class="alert alert--minimal" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__message">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>`}</code></pre>
      <br/>

      <h4>Alert Box</h4>
      <div className="alert hard js-alert" role="alert">
        <header className="alert__header">
          <div className="alert__icon">
            <i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
          </div>
          <div className="alert__heading">
            This is an alert box
          </div>
          <button className="alert__close btn btn--transparent js-alert__close" aria-label="close">
            <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
          </button>
        </header>
        <div className="alert__body">
          <div className="alert__body__inner">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.</p>
          </div>
          <footer className="alert__body__footer text--right">
            <button type="button" className="btn">OK</button>
          </footer>
        </div>
      </div>
      <br/><br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="alert hard js-alert" role="alert">
  <header class="alert__header">
    <div class="alert__icon">
      <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
    </div>
    <div class="alert__heading">
      This is an alert box
    </div>
    <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
      <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
    </button>
  </header>
  <div class="alert__body">
    <div class="alert__body__inner">
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.</p>
    </div>
    <footer class="alert__body__footer text--right">
      <button type="button" class="btn">OK</button>
    </footer>
  </div>
</div>`}</code></pre>

      <h3>Dismissable Alerts</h3>
      <p>This functionality requires javascript. You need to use the classes shown above, or pass specific paramaters when initializing</p>
      <div className="alert alert--success js-alert" role="alert">
        <h4>Success</h4>User was created.
        <button className="alert__close btn btn--transparent js-alert__close" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>
      <br/>
      <div className="alert alert--error js-alert" role="alert">
        <div className="alert__icon">
          <i className="fa fa-ban icon--medium" aria-hidden="true"></i>
        </div>
        <div className="alert__heading">
          This is an error alert
        </div>
        <button className="alert__close btn btn--transparent js-alert__close" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>
      <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="alert alert--success js-alert" role="alert">
  <button class="alert__close js-alert__close" aria-label="close"><i class="fa fa-close"></i></button>
  <h4>Success</h4>User was created.
</div>
<div class="alert alert--error js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-ban icon--medium" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is a error alert
  </div>
  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>`}</code></pre>
      <br/>
      <pre><code className="language-javascript">{`// Using default classes shown in snippet.
// The library looks for the class 'js-alert' and 'js-alert__close' by default.
commonUI.initializeAlert();

// You can have multiple alerts on the page, they will all be initialised

// Using custom selectors
commonUI.initializeAlert(
  {
    selector: '.special-alert',
    closeSelector': .special-alert-close-button'
  }
);

// Automatically closing after time period (in milliseconds)
commonUI.initializeAlert(
  {
    autoCloseTime: 5000
  }
);`}</code></pre>
      <br/>

      <h4>Small Alerts</h4>
      <p>Each alert can also make use of the <code>alert--small</code> class to reduce the height and padding on the alert.</p>

      <div className="push-half-bottom">
        <label htmlFor="alert-type-small" className="display--inline-block push-half--right">Change Type:</label>
        <select id="alert-type-small" className="alert-type-selector" data-selector=".js-alert--small">
          <option value="default">Default</option>
          <option value="info">Info</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>

      <h5>Default</h5>
      <div className="alert alert--small js-alert--small" role="alert">This is a small alert</div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<!-- Default Small Alert -->
<div class="alert alert--small" role="alert">
  This is a small alert
</div>

<!-- Small Info Alert -->
<div class="alert alert--small alert--info" role="alert">
  This is a small info alert
</div>

<!-- Small Success Alert -->
<div class="alert alert--small alert--success" role="alert">
  This is a small success alert
</div>

<!-- Small Warning Alert -->
<div class="alert alert--small alert--warning" role="alert">
  This is a small warning alert
</div>

<!-- Small Error Alert -->
<div class="alert alert--small alert--error" role="alert">
  This is a small error alert
</div>`}</code></pre>

      <h5>Attention</h5>
      <div className="alert alert--small js-alert--small" role="alert">
        <div className="alert__icon">
          <i className="fa fa-exclamation-circle icon--small" aria-hidden="true"></i>
        </div>
        <div className="alert__heading">
          This is an alert
        </div>
      </div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<!-- Default Small Attention Alert -->
<div class="alert alert--small js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-circle icon--small" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is an alert
  </div>
</div>

<!-- Small Info Attention Alert -->
<div class="alert alert--small alert--info js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-info-circle icon--small" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is an info alert
  </div>
</div>

<!-- Small Success Attention Alert -->
<div class="alert alert--small alert--success js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-check icon--small" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is a success alert
  </div>
</div>

<!-- Small Warning Attention Alert -->
<div class="alert alert--small alert--warning js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-triangle icon--small" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is a warning alert
  </div>
</div>

<!-- Small Error Attention Alert -->
<div class="alert alert--small alert--error js-alert" role="alert">
  <div class="alert__icon">
    <i class="fa fa-ban icon--small" aria-hidden="true"></i>
  </div>
  <div class="alert__heading">
    This is an error alert
  </div>
</div>`}</code></pre>

      <h5>Light Alert</h5>
      <p>It is the design suggestion that you do not use full buttons in small, light alerts - only button links are permissible. If a button is supplied then the alert will grow in height to accomodate.</p>
      <div className="alert alert--small alert--light js-alert--small" role="alert">
        This is a small light alert, with a <a href="#">link</a>
        <button className="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<!-- Default Small & Light Alert -->
<div class="alert alert--small alert--light js-alert" role="alert">
  This is a small light alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Small & Light Info Alert -->
<div class="alert alert--small alert--light alert--info js-alert" role="alert">
  This is a small light info alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Small & Light Success Alert -->
<div class="alert alert--small alert--light alert--success js-alert" role="alert">
  This is a small light success alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Small & Light Warning Alert -->
<div class="alert alert--small alert--light alert--warning js-alert" role="alert">
  This is a small light warning alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Small & Light Error Alert -->
<div class="alert alert--small alert--light alert--error js-alert" role="alert">
  This is a small light error alert, with a <a href="#">link</a>
  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>`}</code></pre>
      <br/>

      <h4>Small Minimal Alerts</h4>

      <div className="push-half-bottom">
        <label htmlFor="alert-type-small" className="display--inline-block push-half--right">Change Type:</label>
        <select id="alert-type-small" className="alert-type-selector" data-selector=".js-alert--small-minimal">
          <option value="default">Default</option>
          <option value="info">Info</option>
          <option value="success">Success</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>

      <h5 className="push--top push-half--bottom">Small Minimal Alert with Block Icon and Colored Outline</h5>
      <div className="alert alert--minimal alert--small alert--outline js-alert--small-minimal" role="alert">
        <div className="alert__icon alert__icon--block">
          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        </div>
        <div className="alert__message">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>

      <h5 className="push--top push-half--bottom">Small Minimal Alert with Icon and Colored Outline</h5>
      <div className="alert alert--minimal alert--small alert--outline js-alert--small-minimal" role="alert">
        <div className="alert__icon">
          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        </div>
        <div className="alert__message">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>

      <h5 className="push--top push-half--bottom">Small Minimal Alert with Icon and Gray Outline</h5>
      <div className="alert alert--minimal alert--small js-alert--small-minimal" role="alert">
        <div className="alert__icon">
          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
        </div>
        <div className="alert__message">
          This is an alert
        </div>
        <button className="alert__close btn btn--transparent" aria-label="close">
          <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
        </button>
      </div>

      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Small Minimal Alert with Block Icon and Colored Outline -->
<div class="alert alert--minimal alert--small alert--outline" role="alert">
  <div class="alert__icon alert__icon--block">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
  </div>
  <div class="alert__message">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Small Minimal Alert with Icon and Colored Outline -->
<div class="alert alert--minimal alert--small alert--outline" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
  </div>
  <div class="alert__message">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>

<!-- Small Minimal Alert with Icon and Gray Outline -->
<div class="alert alert--minimal alert--small" role="alert">
  <div class="alert__icon">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
  </div>
  <div class="alert__message">
    This is an alert
  </div>
  <button class="alert__close btn btn--transparent" aria-label="close">
    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
  </button>
</div>`}</code></pre>
      <br/>

      <h5>Alert Box</h5>
      <div className="alert hard js-alert" role="alert">
        <header className="alert--small alert__header">
          <div className="alert__icon">
            <i className="fa fa-exclamation-circle icon--small" aria-hidden="true"></i>
          </div>
          <div className="alert__heading">
            This is an alert box
          </div>
          <button className="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
            <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
          </button>
        </header>
        <div className="alert__body">
          <div className="alert__body__inner">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.</p>
          </div>
          <footer className="alert__body__footer text--right">
            <button type="button" className="btn">OK</button>
          </footer>
        </div>
      </div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="alert hard js-alert" role="alert">
  <header class="alert--small alert__header">
    <div class="alert__icon">
      <i class="fa fa-exclamation-circle icon--small" aria-hidden="true"></i>
    </div>
    <div class="alert__heading">
      This is an alert box
    </div>
    <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
      <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
    </button>
  </header>
  <div class="alert__body">
    <div class="alert__body__inner">
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.</p>
    </div>
    <footer class="alert__body__footer text--right">
      <button type="button" class="btn">OK</button>
    </footer>
  </div>
</div>`}</code></pre>

      <h5>Upgrading Your Browser Alert Box</h5>
      <p>Up to date browser versions will be the current version - 1. So if it is 11.0.0 any browsers lower than 10.0.0 will be considered out of date. However you can overwrite this by passing in a config object with custom version numbers. Any browser versions lower than this will be considered out of date.</p>
      <p>Initialise the update browser functionality as below: </p>
      <pre><code className="language-javascript">{`// This will initialise with the default settings. Current Browser Version - 1
commonUI.initializeAlert({
  selector: '.alert--update-browser',
  updatedBrowser: true,
});

// Initializes with custom browser numbers. Any versions lower than this will be considered out of date.
commonUI.initializeAlert({
  selector: '.alert--update-browser',
  updatedBrowser: {
    chrome: '73.0.0',
    safari: '13.0.0',
    firefox: '66.0.0',
    ie: '12.0.0',
  }
});`}</code></pre>
<br/>
      <div className="alert alert--warning hard js-alert alert--update-browser" role="alert">
        <header className="alert__header">
          <div className="alert__icon">
            <i className="fa fa-exclamation-triangle icon--medium" aria-hidden="true"></i>
          </div>
          <div className="alert__heading">
            Update Browser!
          </div>
          <button className="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
            <i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
          </button>
        </header>
        <div className="alert__body">
          <div className="alert__body__inner">
            <p>Your browser is not up-to-date. We recommend using the latest version for a better experience.</p>
          </div>
        </div>
      </div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="alert alert--warning hard js-alert alert--update-browser" role="alert">
  <header class="alert__header">
    <div class="alert__icon">
      <i class="fa fa-exclamation-triangle icon--medium" aria-hidden="true"></i>
    </div>
    <div class="alert__heading">
      Update Browser!
    </div>
    <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">
      <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
    </button>
  </header>
  <div class="alert__body">
    <div class="alert__body__inner">
      <p>Your browser is not up-to-date. We recommend using the latest version for a better experience.</p>
    </div>
  </div>
</div>`}</code></pre>
      <br/>
      <hr/>
    </section>
    )
  }
}
export default Alerts



// WEBPACK FOOTER //
// ./styleguide/components/sections/Alerts.js